import { styled as muiStyled } from '@mui/material'

export const AddictionTypesCardHeadingImage = muiStyled('img')(
  ({ theme }) => `
    width: 100%;
    aspect-ratio: 1;
    max-width:38px;
    @media(min-width: 768px){
    max-width:68px;
    }
`,
)

export const BackgroundContainerForPublicPagesVarOne = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  padding: 24px 24px 48px 24px;
  justify-content: center;
  gap: 50px;
  background: #1c2120;
  @media (min-width: 996px){
    height: 500px;
  }
`,
)
